import { BasePanelComponent } from '@modules/base-panel/pages/base-panel/base-panel.component';
import { BasePanelCanActivateGuard } from '@modules/base-panel/guards/base-panel-can-activate.guard';

import { TailwindTestGuard } from '@modules/tailwind-test/tailwind-test.guard';
import { CanvasCanActivateGuard } from '@modules/canvas/guards/canvas-can-activate.guard';
import { FaqCanActivateGuard } from '@modules/faq/guards/faq-can-activate.guard';
import { FunnelModuleResolver } from '@modules/funnels/shared/services/funnel-module.resolver';
import { TacticsCanActivateGuard } from '@modules/tactics/guards/tactics-can-activate.guard';
import { UserSettingsCanActivateGuard } from '@modules/user-settings/guards/user-settings-can-activate.guard';
import { UsersCanActivateGuard } from '@modules/users/guards/users-can-activate.guard';
import { HasActiveSubscriptionGuard } from '@shared/guards/has-active-subscription.guard';

export const PanelRoutes = [
  {
    path: '',
    component: BasePanelComponent,
    canActivate: [BasePanelCanActivateGuard],
    children: [
      {
        path: 'home',
        canActivate: [HasActiveSubscriptionGuard],
        loadChildren: () => import('@modules/home/home-page.module').then((m) => m.HomePageModule),
      },
      {
        path: 'funnels',
        loadChildren: () => import('@modules/funnels/funnels.module').then((m) => m.FunnelsModule),
        resolve: {
          steps: FunnelModuleResolver,
        },
      },
      {
        path: 'tactics',
        canActivate: [TacticsCanActivateGuard],
        loadChildren: () => import('@modules/tactics/tactics.module').then((m) => m.TacticsModule),
      },
      {
        path: 'work-flows',
        loadChildren: () => import('@modules/work-flows/work-flows.module').then((m) => m.WorkFlowsModule),
      },
      {
        path: 'users',
        canActivate: [UsersCanActivateGuard],
        loadChildren: () => import('@modules/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'account',
        canActivate: [UserSettingsCanActivateGuard],
        loadChildren: () => import('@modules/user-settings/user-settings.module').then((m) => m.UserSettingsModule),
      },
      {
        path: 'business-data',
        loadChildren: () => import('@modules/business-data/business-data.module').then((m) => m.BusinessDataModule),
      },
      {
        path: 'faq',
        canActivate: [FaqCanActivateGuard],
        loadChildren: () => import('@modules/faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'canvas',
        canActivate: [CanvasCanActivateGuard],
        loadChildren: () => import('@modules/canvas/canvas.module').then((m) => m.CanvasModule),
      },
      {
        path: 'funnels/f/d/:id/marketing-assistant',
        name: 'marketing-assistant',
        loadChildren: () =>
          import('@shared/components/chatgpt-message-box/chatgpt-message-box.module').then(
            (m) => m.ChatgptMessageModule,
          ),
        data: {
          metaTitle: 'Marketing Assistant',
        },
      },
      {
        path: 'ad-library',
        loadChildren: () => import('@modules/ad-library/ad-library.module').then((m) => m.AdLibraryModule),
      },
      {
        path: 'tailwind',
        canActivate: [TailwindTestGuard],
        loadChildren: () => import('@modules/tailwind-test/tailwind-test.module').then((m) => m.TailwindTestModule),
      },
    ],
  },
];
